export default __webpack_public_path__ + "static/media/CALENDÁRIO ACADÉMICO REAJUSTADO 2021-2022.e6d2070c.pdf";